import React, { useState } from "react"
import VizSensor from "react-visibility-sensor"
import classnames from "classnames"

//Components
import Pic from "../images/pic"

const GrayZone = () => {
  const [isVisible, setVisibility] = useState(false)
  let baseClass = classnames(
    "grid",
    "grid-cols-12",
    { "opacity-0": !isVisible },
    { "text-slide-in": isVisible }
  )

  return (
    <section id="gray" className="h-full blue-zone bg-gray">
      <VizSensor
        onChange={setVisibility}
        active={!isVisible}
        partialVisibility={true}
      >
        <div className={baseClass}>
          <div className="lg:col-start-2 lg:col-span-3 col-start-5 col-span-4 mt-5 xl:p-24 lg:p-12 p-4">
            <Pic filename="home/ShieldB.png" />
          </div>
          <div className="col-span-12 p-10 md:p-20 lg:py-20 lg:px-0 lg:col-start-5 lg:col-span-6">
            <h2 className="font-medium text-left text-gray-800 text-4xl lg:text-4xl">
              ¿Qué me cubre Alex?
            </h2>
            <h4 className="font-normal tracking-wide leading-normal text-xl">
              Este seguro ofrece coberturas de fallecimiento o invalidez
              permanente <br />o desmembramiento del asegurado, causados por un
              accidente.
            </h4>
            <h4 className="font-normal tracking-wide leading-normal text-xl">
              Tienes tres opciones de capital asegurado de $25.000, $50.000 y
              $100.000, y además incluye asistencia funeraria y repatriación de
              restos mortales.
            </h4>
          </div>
        </div>
      </VizSensor>
    </section>
  )
}

export default GrayZone
